import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';

function ConfirmDialog(props) {
  const { visible, setVisible, onReject, onHide, onAccept, content, loading } = props;
  const { t } = useTranslation();

  const footer = () => (
    <div>
      <Button
        label={t('formLayout.action.cancel')}
        className="w-8rem"
        severity="danger"
        onClick={onReject}
        autoFocus
      />
      <Button
        label={t('employee.ok')}
        className="w-8rem"
        severity="info"
        onClick={onAccept}
        loading={loading}
      />
    </div>
  );

  return (
    <Dialog
      header={<p className="text-blue-500">{t('formLayout.action.confirm')}</p>}
      visible={visible}
      position="center"
      style={{ width: '400px' }}
      onHide={onHide || (() => setVisible(false))}
      draggable={false}
      footer={footer}
    >
      <div className="text-lg">{content}</div>
    </Dialog>
  );
}

export default React.memo(ConfirmDialog);

ConfirmDialog.propTypes = {
  onReject: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.any.isRequired,
  loading: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  onHide: PropTypes.func,
};

ConfirmDialog.defaultProps = {
  loading: false,
  onHide: null,
};
